export const USER_ADDRESSES_API = 'addresses/{{StoreId}}/{{language}}?areacode={{areaCode}}';
